import {InjectionToken} from "@angular/core";
import {SplashLoaderPort} from "../ports/splash-loader.port";

export const SPLASH_LOADER = new InjectionToken<SplashLoaderPort>('SPLASH_LOADER');
